import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import RankingSalesReportMiddleware from '../../../../middleware/modules/report/ranking-sales';
import { Helmet } from 'react-helmet';
import i18n from '../../../../i18n';
import RankingSalesReport from '../../../../components/modules/report/ranking-sales';
// middlewares
 

const mapStateToProps = ({ auth,rankingSalesReport }) => ({
  isProcessing: rankingSalesReport.isProcessing,
  isError: rankingSalesReport.isError,
  errorMessage: rankingSalesReport.errorMessage,
  data:rankingSalesReport.data,
  showModal:rankingSalesReport.showModal,
  helperList:rankingSalesReport.helperRankingSalesReport
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getHelper:(params)=>RankingSalesReportMiddleware.getHelper(params),
    reset: () =>RankingSalesReportMiddleware.reset(),
    excel: (data) =>RankingSalesReportMiddleware.beforeShowExcel(data),
  }, dispatch);
};
class RankingSalesReportContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    data: PropTypes.any,
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
  }
  componentWillMount() {
    this.props.reset();
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Ranking Sales Report")}
          </title>
        </Helmet>
      <RankingSalesReport
        {...this.props}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RankingSalesReportContainer);
